interface ISettingTitle {
  title?: string;
  description?: string;
}

export const SettingTitle = ({ title, description }: ISettingTitle) => {
  return (
    <div className={'-tracking-[0.01em] font-inter'}>
      <h2 className="text-base/[1] font-medium mb-3.5">{title}</h2>
      <p className="text-base-500 text-sm/[1]">{description}</p>
    </div>
  );
};
